/**
 * The product-detail testimonial sits under the gallery on desktop and under the
 * trust badges on mobile. It is one static block, rendered once in the desktop
 * slot; below 750px it is moved into the mobile slot, and back again above it.
 */
const mobile = window.matchMedia('(max-width: 749px)');

function placeTestimonials() {
  for (const section of document.querySelectorAll('.product-detail-section')) {
    const desktopSlot = section.querySelector('[data-testimonial-slot="desktop"]');
    const mobileSlot = section.querySelector('[data-testimonial-slot="mobile"]');
    if (!desktopSlot || !mobileSlot) continue;

    const target = mobile.matches ? mobileSlot : desktopSlot;
    const source = mobile.matches ? desktopSlot : mobileSlot;
    if (source.childElementCount > 0) target.append(...source.children);
  }
}

placeTestimonials();
mobile.addEventListener('change', placeTestimonials);
document.addEventListener('shopify:section:load', placeTestimonials);
